import React from 'react'

import {
  Button,
  ButtonClean,
  ConfirmModal,
  Skeleton,
  useModalContext,
} from '@fourthwall/components'
import { GoogleAnalyticsIcon } from '@fourthwall/icons'

import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics'
import * as S from './GoogleAnalyticsBar.styled'

export const GoogleAnalyticsBar = () => {
  const { open } = useModalContext()
  const { data, isLoading, connectLink, onDisconnect } = useGoogleAnalytics()

  const status = data?.type

  // TODO: Discuss and handle other statuses

  if (!status || isLoading) {
    return <GoogleAnalyticsBarSkeleton />
  }

  const handleDisconnect = () => {
    open(ConfirmModal, {
      title: 'Are you sure you want to disconnect from Google Analytics?',
      confirmLabel: 'Yes, disconnect',
      confirmAppearance: 'destructive',
      onConfirm: onDisconnect,
    })
  }

  const getMainContent = () => {
    if (status === 'CONNECTED') {
      return (
        <>
          {data.email && <S.Email>{data.email}</S.Email>}
          <ButtonClean appearance="secondary" label="Disconnect" onClick={handleDisconnect} />
        </>
      )
    }

    return <S.Info>Connect Google Analytics to see visitors and other stats</S.Info>
  }

  const renderActionButton = () => {
    const commonProps = {
      leftIcon: <GoogleAnalyticsIcon width={16} height={16} />,
      size: 'xsmall' as const,
    }

    if (status !== 'CONNECTED') {
      return <Button {...commonProps} href={connectLink} label="Connect" />
    }

    return (
      <Button
        {...commonProps}
        label="View"
        href={data.googleAnalyticsDashboardUri}
        target="_blank"
      />
    )
  }

  return (
    <S.Container>
      <S.MainContent>{getMainContent()}</S.MainContent>
      <S.Actions>{renderActionButton()}</S.Actions>
    </S.Container>
  )
}

export const GoogleAnalyticsBarSkeleton = () => {
  return (
    <Skeleton>
      <Skeleton.Shape width={290} height={40} />
    </Skeleton>
  )
}
